import React, { useState, useEffect } from 'react'
import { Form, Select } from 'antd'
import checkFlag from '../../../helpers/featureFlags'

const { Option } = Select

const SelectPaymentMethodV2 = (props) => {
  const [allowWire, setAllowWire] = useState(false)
  const [achDuration, setAchDuration] = useState('4-6 business days')

  useEffect(() => {
    if (props.bankAccountSource === 'UN') {
      setAllowWire(true)
      setAchDuration('2-3 business days')
      return
    }
    if (props.allowWire) {
      setAllowWire(true)
      return
    }
  }, [props])

  return (
    <Form.Item
      label={props.label}
      name={props.name}
      rules={[{ required: true, message: 'Please select a method.' }]}
      initialValue={props.initialValue || ''}
    >
      {checkFlag('paymentsV2') ? (
        <Select placeholder='Select your Payment Type' style={{ width: '100%' }} onChange={props.onChange} allowClear dropdownMatchSelectWidth={false}>
          <Option value='ach'>{`ACH (${achDuration})`}</Option>
          {allowWire && <Option value='wire'>Wire (0-1 business days, min $1,000)</Option>}
        </Select>
      ) : (
        <Select placeholder='Select your Payment Type' style={{ width: '100%' }} onChange={props.onChange} allowClear dropdownMatchSelectWidth={false}>
          <Option value='ach'>ACH (2-3 business days)</Option>
          <Option value='wire'>Wire (0-1 business days, min $1,000)</Option>
        </Select>
      )}
    </Form.Item>
  )
}

export default SelectPaymentMethodV2
